<template>
    <div class="bg-[#1D1D1D] border-[1px] border-[#252526] w-[400px] h-[305px] rounded-[10px] mt-[25px] pt-[10px]">
        <div class="bg-[#4EAE3B] text-[13px] font-bold text-center rounded-[4px] mx-[14px] py-[2px]">
            ДОКУМЕНТИ
        </div>
        <image-viewer 
            class="absolute z-40"
            v-if="showImageViewer"
            :image="currentImage"
            :photoType="currentPhotoType"
            @close="showImageViewer = false"
            @deletePhoto="deletePhoto(currentImage, currentPhotoType)"
        />
        <div class="mx-[12px]">
            <div class="flex justify-between items-center align-middle mb-[6px] mt-[10px]">
                <div class="w-[30%]">
                    <input v-model="store.student.name_eng" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="Ім'я англійською" type="text">
                </div>
                <div class="font-normal text-[#FFFFFF80] opacity-90 text-start text-[11px] w-[70%]">
                    name
                </div>
            </div>
            <div class="flex justify-between items-center align-middle mb-[4px]">
                <div class="w-[30%]">
                    <input v-model="store.student.surname_eng" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="Прізвище англійською" type="text">
                </div>
                <div class="font-normal text-[#FFFFFF80] opacity-90 text-start text-[11px] w-[70%]">
                    surname
                </div>
            </div>
            <div class="flex justify-between items-center align-middle mb-[3px]">
                <div class="flex items-center w-[50%]">
                    <div class="w-[60%]">
                        <input v-model="store.student.passport" @change="$emit('update:passport', $event.target.value)" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="XX000000" type="text">
                    </div>
                    <div class="font-normal text-[#FFFFFF80] opacity-90 text-start text-[11px] w-[20%]">
                        паспорт
                    </div>
                </div>
                <div class="text-sm flex justify-end items-end mr-[5px]">
                    <img 
                        v-for="passportPhoto in store.student.passport_files"
                        @click="setImageToView(passportPhoto, 'passport')"
                        src="../../assets/picture_icon.svg" 
                        class="mx-[2px] w-[16px] cursor-pointer"
                    >
                    <img 
                        @click="uploadPassportPhoto"
                        src="../../assets/upload_icon_light.svg" 
                        class="w-[16px] ml-2 cursor-pointer"
                    >
                    <input 
                        @change="store.student.passport_files.push($event.target.files[0])"
                        ref="passportFilesInput" 
                        type="file" 
                        class="hidden"
                    >
                </div>
            </div>


            <div class="flex justify-between items-center align-middle mb-[5px]">
                <div class="flex items-center w-[50%]">
                    <div class="w-[60%]">
                        <input v-model="store.student.id_number" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="1234567890" type="text">
                    </div>
                    <div class="font-normal text-[#FFFFFF80] opacity-90 text-start text-[11px] w-[20%]">
                        ID код
                    </div>
                </div>
                <div class="text-sm flex justify-end items-end mr-[5px]">
                    <img 
                        v-for="idNumber in store.student.id_code_files"
                        @click="setImageToView(idNumber, 'idNumber')"
                        src="../../assets/picture_icon.svg" 
                        class="mx-[2px] w-[16px] cursor-pointer"
                    >
                    <img 
                        @click="uploadIdNumberPhoto"
                        src="../../assets/upload_icon_light.svg" 
                        class="w-[16px] ml-2 cursor-pointer"
                    >
                    <input 
                        @change="store.student.id_code_files.push($event.target.files[0])"
                        ref="idNumberFilesInput" 
                        type="file" 
                        class="hidden"
                    >
                </div>
            </div>

            <div class="flex justify-between items-center align-middle mb-[8px]">
                <div class="w-[30%]">
                    <input :value="endPasspotDate" @change="endPasspotDate = $event.target.value" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="Дата закінчення паспорту" type="date">
                </div>
                <div class="font-normal text-[#FFFFFF80] opacity-90 text-start text-[11px] w-[70%]">
                    дата закінчення паспорту
                </div>
            </div>

            <div class="flex justify-between items-center align-middle mb-[8px]">
                <div class="flex items-center w-[50%]">
                    <div class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60">
                        Довіреність
                    </div>
                </div>
                <div class="text-sm flex justify-end items-end mr-[5px]">
                    <img 
                        v-for="attorney in store.student.attorney_child_files" 
                        @click="setImageToView(attorney, 'attorney')"
                        src="../../assets/picture_icon.svg" 
                        class="mx-[2px] w-[16px] cursor-pointer"
                    >
                    <img 
                        @click="uploadAttorneyPhoto"
                        src="../../assets/upload_icon_light.svg" 
                        class="w-[16px] ml-2 cursor-pointer"
                    >
                    <input 
                        @change="store.student.attorney_child_files.push($event.target.files[0])"
                        ref="attorneyFilesInput" 
                        type="file" 
                        class="hidden"
                    >
                </div>
            </div>

            
            <div class="flex justify-between items-center align-middle mb-[5px]">
                <div class="flex items-center w-[50%]">
                    <div class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60">
                        Фото на паспорт
                    </div>
                </div>
                <div class="text-sm flex justify-end items-end mr-[5px]">
                    <img 
                        v-for="photoForPassport in store.student.photo_for_passport" 
                        @click="setImageToView(photoForPassport, 'photo_for_passport')"
                        src="../../assets/picture_icon.svg" 
                        class="mx-[2px] w-[16px] cursor-pointer"
                    >
                    <img 
                        @click="uploadPhotoForPassport"
                        src="../../assets/upload_icon_light.svg" 
                        class="w-[16px] ml-2 cursor-pointer"
                    >
                    <input 
                        @change="store.student.photo_for_passport.push($event.target.files[0])"
                        ref="photoForPassportInput" 
                        type="file" 
                        class="hidden"
                    >
                </div>
            </div>

            <div class="flex justify-between items-center align-middle mb-[3px]">
                <div class="w-[80%]">
                    <input v-model="store.student.address" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="Demo" type="text">
                </div>
                <div class="font-normal text-[#FFFFFF80] opacity-90 relative top-[3px] text-end text-[11px] w-[70%]">
                    де народився (місто, область)
                </div>
            </div>

            <div class="flex justify-between items-center align-middle mb-[10px]">
                <div class="w-[35%]">
                    <input v-model="store.student.patrons[0].name" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-[90%] truncate placeholder:opacity-60" placeholder="Ім'я та прізвище" type="text">
                </div>
                <div class="font-normal text-[#FFFFFF80] opacity-90 relative top-[3px] text-center text-[11px] w-[30%]">
                    відпов. особа
                </div>
                <div class="w-[35%]">
                    <input v-model="store.student.patrons[0].phone_number" class="text-[#FFFFFF] font-semibold text-[13px] outline-none bg-transparent border-none w-full truncate text-end placeholder:opacity-60" placeholder="Телефон" type="text">
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import { ref, computed } from 'vue'
    import { useMainStore } from '../../store/mainStore'

    import ImageViewer from './ImageViewer.vue'
    
    function formateDate(date) {
        const dateObj = new Date(date)
        const year = dateObj.getFullYear()
        const month = dateObj.getMonth() + 1 > 9 ? dateObj.getMonth() + 1 : `0${dateObj.getMonth() + 1}`
        const day = dateObj.getDate() > 9 ? dateObj.getDate() : `0${dateObj.getDate()}`
        return `${year}-${month}-${day}`
    }

    export default {
        name: 'documentary-card',

        setup(props, { emit }) {
            const store = useMainStore()
            const passportFilesInput = ref(null)
            const idNumberFilesInput = ref(null)
            const attorneyFilesInput = ref(null)
            const photoForPassportInput = ref(null)
            const currentImage = ref(null)
            const showImageViewer = ref(false)
            const currentPhotoType = ref(null)

            const newPassportFiles = ref([])
            const newIdNumberFiles = ref([])
            const newAttorneyFiles = ref([])
            const newPhotosForPassport = ref([])

            const endPasspotDate = computed({
                get() {
                    if (!store.student.passport_end_date.includes('T'))
                        return store.student.passport_end_date
                    return formateDate(store.student.passport_end_date)
                },
                set(value) {
                    store.student.passport_end_date = new Date(value).toISOString().split('.')[0]
                }
            })

            const uploadPassportPhoto = () => {
                passportFilesInput.value.click()
            }

            const uploadIdNumberPhoto = () => {
                idNumberFilesInput.value.click()
            }

            const uploadAttorneyPhoto = () => {
                attorneyFilesInput.value.click()
            }

            const uploadPhotoForPassport = () => {
                photoForPassportInput.value.click()
            }

            const setImageToView = (image, type) => {
                currentImage.value = image
                currentPhotoType.value = type
                showImageViewer.value = true
                console.log(currentPhotoType.value)
            }

            const deletePhoto = (currentPhoto, currentPhotoType) => {
                if (currentPhotoType === 'passport') {
                    store.student.passport_files = store.student.passport_files.filter((photo) => photo !== currentPhoto)
                } else if (currentPhotoType === 'idNumber') {
                    store.student.id_code_files = store.student.id_code_files.filter((photo) => photo !== currentPhoto)
                } else if (currentPhotoType === 'attorney') {
                    store.student.attorney_child_files = store.student.attorney_child_files.filter((photo) => photo !== currentPhoto)
                } else if (currentPhotoType === 'photo_for_passport') {
                    store.student.photo_for_passport = store.student.photo_for_passport.filter((photo) => photo !== currentPhoto)
                }
            }

            return {
                uploadPassportPhoto,
                passportFilesInput,
                currentImage,
                showImageViewer,
                setImageToView,
                uploadIdNumberPhoto,
                idNumberFilesInput,
                currentPhotoType,
                attorneyFilesInput,
                uploadAttorneyPhoto,
                endPasspotDate,
                photoForPassportInput,
                uploadPhotoForPassport,
                store,
                newPassportFiles,
                newIdNumberFiles,
                newAttorneyFiles,
                newPhotosForPassport,
                deletePhoto
            }
        },

        components: {
            ImageViewer
        }
    }
</script>


<style scoped>


    ::-webkit-calendar-picker-indicator {
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 24 24"><path fill="%23FFFFFF" d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"/></svg>');
    }

</style>